import dayjs from "dayjs"

export const durationBetween = function(start, end = Date.now()) {
    const djsStart = dayjs(start)
    const djsEnd = dayjs(end)

    return dayjs.duration(djsStart.diff(djsEnd))
}

export const formatDate = function(value, pattern = "localDate") {
    if (!value) return null

    const resolvedPattern = resolvePattern(pattern)

    const djsDate = dayjs(value)

    if (resolvedPattern === "iso") {
        return djsDate.toISOString()
    }

    return djsDate.format(resolvedPattern)
}


function resolvePattern(pattern) {
    switch (pattern) {
        case "localDate":
            return "MM/DD/YYYY"
        case "miniLocalDate":
            return "M/D/YYYY"
        case "microLocalDate":
            return "M/D/YY"
        case "semiVerboseDate":
            return "MMMM D, YYYY"
        case "localDateTime":
            return "MM/DD/YYYY hh:mm a"
        case "miniLocalDateTime":
            return "M/D/YYYY h:mm a"
        case "microLocalDateTime":
            return "M/D/YYYY h:mm a"
        case "isoDate":
            return "YYYY-MM-DD"
        case "isoDateTime":
            return "iso"
        default:
            return pattern
    }
}
